import { useTranslation as usePublicI18n } from "react-i18next";
import { publicText, publicTemplate } from "../publicText";
import React, { useEffect, useRef } from "react";
export function useDocumentTitle(title) {
  useEffect(() => {
    const previous = document.title;
    document.title = title;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
export function Reveal({
  children,
  className = "",
  delay = 0,
  as: Tag = "div"
}) {
  usePublicI18n();
  const ref = useRef(null);
  useEffect(() => {
    const element = ref.current;
    if (!element) return undefined;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      element.classList.add("is-visible");
      return undefined;
    }
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        element.classList.add("is-visible");
        observer.unobserve(element);
      }
    }, {
      threshold: 0.12,
      rootMargin: "0px 0px -48px 0px"
    });
    observer.observe(element);
    return () => observer.disconnect();
  }, []);
  return <Tag ref={ref} className={`science-reveal ${className}`.trim()} style={{
    "--reveal-delay": `${delay}ms`
  }}>
      {publicText(children)}
    </Tag>;
}
export function formatNumber(value, digits = 1) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) {
    return "—";
  }
  return Number(value).toLocaleString("ja-JP", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits
  });
}
